//import { useEffect, useMemo, useState } from "react";
//import styled from "styled-components";

function bbCodeTranslator(label, linkTitle = null) {
  // replace the BB-code with HTML values based on a regex
  // "In [cssClasses=strong]3 simple steps[/cssClasses], get your...", will result in "In <span class='strong'>3 simple steps</span>, get your..."

  let finalLabel = label.replace(/<([\w /="]+)>/g, "");

  finalLabel = finalLabel
    // Example: [br] will be replaced by <br>
    .replace(/\[br]/g, "<br>")
    // Example: [b]this is bold text[/b] will be replaced by <strong>this is bold text</strong>
    .replace(/\[b]\s*(.+?)\s*\[\/b]/g, "<strong>$1</strong>")
    // Example: [strong]this is also bold text[/strong] will be replaced by <strong>this is also bold text</strong>
    .replace(/\[strong]\s*(.+?)\s*\[\/strong]/g, "<strong>$1</strong>")
    // Example: [i]this is italic text[/i] will be replaced by <em>this is italic text</em>
    .replace(/\[i]\s*(.+?)\s*\[\/i]/g, "<em>$1</em>")
    // Example: [u]this is underlined text[/u] will be replaced by <u>this is underlined text</u>
    .replace(/\[u]\s*(.+?)\s*\[\/u]/g, "<u>$1</u>")
    // Example: [span]this is some text[/span] will be replaced by <span>this is some text</span>
    .replace(/\[span]\s*(.+?)\s*\[\/span]/g, "<span>$1</span>")
    // Example: [cssClasses=some-class]this is some text[/cssClasses] will be replaced by <span class='some-class'>this is some text</span>
    .replace(
      /\[cssClasses=([^\]]+)\]\s*(.+?)\s*\[\/cssClasses\]/g,
      "<span class='$1'>$2</span>"
    )
    // Example: [url=https://example.com]this is a link[/url] will be replaced by <a href='https://example.com' title='this is a link' target='_blank'>this is a link</a>
    .replace(
      /\[url=([^\]]+)\]\s*(.+?)\s*\[\/url\]/g,
      (match, url, text) => {
        const cleanLinkTitle = linkTitle
          ? linkTitle
              .replace(/\[br\]/gi, '')
              .replace(/\[link=([^\]]+)\]/g, '')
              .replace(/\[\/link\]/g, '')
          : text;
        return `<a href='${url}' title='${cleanLinkTitle}' target='_blank'>${text}</a>`;
      }
    )
    .replace(
      /\[link=([^\]]+)\]\s*(.+?)\s*\[\/link\]/g,
      (match, url, text) => {
        const cleanLinkTitle = linkTitle
          ? linkTitle
              .replace(/\[br\]/gi, '')
              .replace(/\[link=([^\]]+)\]/g, '')
              .replace(/\[\/link\]/g, '')
          : text;
        return `<a href='${url}' title='${cleanLinkTitle}' >${text}</a>`;
      }
    );

  return finalLabel;
}

// function to safely return the inner-HTML to avoid XSS-attacks.
// more info: https://facebook.github.io/react/tips/dangerously-set-inner-html.html
function createMarkup(label) {
  return { __html: label };
}

const BBCode = ({ children, className = null, title = null, linkTitle = null }) => {
  // Nettoyer le texte des balises BBCode pour le tooltip par défaut
  const cleanText =
    typeof children === 'string'
      ? children
          .replace(/\[.*?\]/g, '') // Retire toutes les balises BBCode [...]
          .replace(/<.*?>/g, '') // Retire toutes les balises HTML <...>
          .trim()
      : '';

  const finalTitle = title || (cleanText && children ? cleanText : null);

  return children ? (
    <span
      className={className}
      title={finalTitle}
      dangerouslySetInnerHTML={createMarkup(bbCodeTranslator(children, linkTitle))}
    />
  ) : null;
};

// Example usage
// <BBCode>{text}</BBCode>

export default BBCode;
